<template>
  <div class="comments">
    <div class="header">
      <div class="left">
        <CommentSvg />
        Comments
      </div>
      <span class="q-mr-sm">({{ newAndOldComments.length }})</span>
    </div>

    <div class="comments-list q-mt-sm">
      <div class="new-comment">
        <div :style="{ background: user.color }" class="participant">
          {{ userInitials }}
        </div>

        <CommentInput v-model="newComment" :disable="commentEditMode" @comment="addComment" />
      </div>

      <transition-group name="comment" tag="div" class="comments-wrapper">
        <SingleComment
          v-for="(comment, index) of newAndOldComments"
          :key="comment.id"
          :comment="comment"
          :todo-id="editItem.id"
          :has-permissions="user.id === comment.created_by.id"
          @edit-mode-changed="commentEditMode = $event"
          @comment-updated="commentUpdated($event, index)"
          @comment-deleted="commentDeleted(index)"
        />
      </transition-group>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import * as apiTo from '../api'
import { cloneDeep } from 'lodash'
// Components
import SingleComment from './SingleComment'
import CommentInput from './CommentInput'
import CommentSvg from '@/reusable/svg-icons/CommentSvg'

export default {
  components: {
    SingleComment,
    CommentInput,
    CommentSvg
  },

  props: {
    fromPage: String,
    editItem: Object,
    comments: Array
  },

  data: () => ({
    newComment: '',
    newAndOldComments: [],
    commentEditMode: false
  }),

  computed: {
    ...mapState({ user: state => state.user }),

    userInitials() {
      if (!this.user) return
      const [name, lastName] = this.user.name.split(' ')
      const nameFirstLetter = name ? name.slice(0, 1).toUpperCase() : ''
      const lastNameFirstLetter = lastName ? lastName.slice(0, 1).toUpperCase() : ''

      return nameFirstLetter + lastNameFirstLetter
    }
  },

  watch: {
    comments: {
      handler(val) {
        if (!val) return
        this.newAndOldComments = cloneDeep(val)
      },
      immediate: true
    }
  },

  methods: {
    addComment() {
      apiTo.createComment(this.editItem.id, { body: this.newComment }).then(({ data }) => {
        this.newAndOldComments.unshift(data.result)
        this.newComment = ''
        this.incrementOrDecrementCommentsCount(1)
      })
    },

    incrementOrDecrementCommentsCount(increment) {
      if (this.fromPage === 'kanban') {
        this.$store.commit('kanban-board/incrementOrDecrementCommentsCount', {
          todoId: this.editItem.id,
          increment
        })
      }
    },

    commentUpdated(updatedComment, index) {
      this.newAndOldComments.splice(index, 1, updatedComment)
    },

    commentDeleted(index) {
      this.newAndOldComments.splice(index, 1)
      this.incrementOrDecrementCommentsCount(-1)
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~@/styles/stylus/custom-variables'

.comments {
  > .header {
    padding 10px 0
    display grid
    align-items center
    grid-auto-flow column
    justify-content space-between
    margin 5px 0
    width 100%
    border-bottom 1px solid rgba(0,0,0,0.12)

    > .left {
      display grid
      grid-auto-flow column
      align-items center
      gap 3px
    }
  }
}

.comments-list {
  display grid
  gap 10px
  padding-right 10px
  padding-bottom 10px

  .new-comment {
    display grid
    grid-template-columns auto 1fr
    justify-content start
    gap 10px

    .participant {
      border-radius 50%
      width 35px
      height 35px
      font-size 0.75rem
      display flex
      justify-content center
      align-items center
      border 2px solid white
      letter-spacing -1px
      color white
      font-weight 500
      cursor pointer
    }

    .body {
      display grid
      gap 5px

      .details {
        display grid
        grid-template-columns auto auto
        justify-content space-between
        align-items center

        .name {
          display grid
        }
      }
    }
  }
  .comments-wrapper {
    display grid
    gap 15px
  }
}

.comment-enter-active, .comment-leave-active {
  transition: all 0.5s;
}
.comment-enter, .comment-leave-to /* .list-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
